'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _reject = require('lodash/reject');

var _reject2 = _interopRequireDefault(_reject);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _sortBy = require('lodash/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _immutableOps = require('immutable-ops');

var _immutableOps2 = _interopRequireDefault(_immutableOps);

var _constants = require('../constants');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTS = {
    idAttribute: 'id',
    arrName: 'items',
    mapName: 'itemsById'
};

function idSequencer(_currMax, userPassedId) {
    var currMax = _currMax;
    var newMax = void 0;
    var newId = void 0;

    if (currMax === undefined) {
        currMax = -1;
    }

    if (userPassedId === undefined) {
        newMax = currMax + 1;
        newId = newMax;
    } else {
        newMax = Math.max(currMax + 1, userPassedId);
        newId = userPassedId;
    }

    return [newMax, newId];
}

var Table = function () {
    function Table(userOpts) {
        (0, _classCallCheck3.default)(this, Table);

        (0, _assign2.default)(this, DEFAULT_OPTS, userOpts);
    }

    Table.prototype.accessId = function accessId(branch, id) {
        return branch[this.mapName][id];
    };

    Table.prototype.idExists = function idExists(branch, id) {
        return branch[this.mapName].hasOwnProperty(id);
    };

    Table.prototype.accessIdList = function accessIdList(branch) {
        return branch[this.arrName];
    };

    Table.prototype.accessList = function accessList(branch) {
        var _this = this;

        return branch[this.arrName].map(function (id) {
            return _this.accessId(branch, id);
        });
    };

    Table.prototype.getMaxId = function getMaxId(branch) {
        return this.getMeta(branch, 'maxId');
    };

    Table.prototype.setMaxId = function setMaxId(tx, branch, newMaxId) {
        return this.setMeta(tx, branch, 'maxId', newMaxId);
    };

    Table.prototype.nextId = function nextId(id) {
        return id + 1;
    };

    Table.prototype.query = function query(branch, clauses) {
        var _this2 = this;

        if (clauses.length === 0) {
            return this.accessList(branch);
        }

        var idAttribute = this.idAttribute;


        var optimallyOrderedClauses = (0, _sortBy2.default)(clauses, function (clause) {
            if ((0, _utils.clauseFiltersByAttribute)(clause, idAttribute)) {
                return 1;
            }

            if ((0, _utils.clauseReducesResultSetSize)(clause)) {
                return 2;
            }

            return 3;
        });

        var reducer = function reducer(rows, clause) {
            var type = clause.type,
                payload = clause.payload;

            if (!rows) {
                if ((0, _utils.clauseFiltersByAttribute)(clause, idAttribute)) {
                    var id = payload[idAttribute];

                    return _this2.idExists(branch, id) ? [_this2.accessId(branch, id)] : [];
                }

                return reducer(_this2.accessList(branch), clause);
            }

            switch (type) {
                case _constants.FILTER:
                    {
                        return (0, _filter2.default)(rows, payload);
                    }
                case _constants.EXCLUDE:
                    {
                        return (0, _reject2.default)(rows, payload);
                    }
                case _constants.ORDER_BY:
                    {
                        var _payload = (0, _slicedToArray3.default)(payload, 2),
                            iteratees = _payload[0],
                            orders = _payload[1];

                        return (0, _orderBy2.default)(rows, iteratees, orders);
                    }
                default:
                    return rows;
            }
        };

        return optimallyOrderedClauses.reduce(reducer, undefined);
    };

    Table.prototype.getEmptyState = function getEmptyState() {
        var _ref;

        return _ref = {}, (0, _defineProperty3.default)(_ref, this.arrName, []), (0, _defineProperty3.default)(_ref, this.mapName, {}), (0, _defineProperty3.default)(_ref, 'meta', {}), _ref;
    };

    Table.prototype.setMeta = function setMeta(tx, branch, key, value) {
        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;

        if (withMutations) {
            var res = _immutableOps2.default.mutable.setIn(['meta', key], value, branch);
            return res;
        }

        return _immutableOps2.default.batch.setIn(batchToken, ['meta', key], value, branch);
    };

    Table.prototype.getMeta = function getMeta(branch, key) {
        return branch.meta[key];
    };

    Table.prototype.insert = function insert(tx, branch, entry) {
        var _ops$batch$merge2;

        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;


        var hasId = entry.hasOwnProperty(this.idAttribute);

        var workingState = branch;

        var _idSequencer = idSequencer(this.getMaxId(branch), entry[this.idAttribute]),
            _idSequencer2 = (0, _slicedToArray3.default)(_idSequencer, 2),
            newMaxId = _idSequencer2[0],
            id = _idSequencer2[1];

        workingState = this.setMaxId(tx, branch, newMaxId);

        var finalEntry = hasId ? entry : _immutableOps2.default.batch.set(batchToken, this.idAttribute, id, entry);

        if (withMutations) {
            _immutableOps2.default.mutable.push(id, workingState[this.arrName]);
            _immutableOps2.default.mutable.set(id, finalEntry, workingState[this.mapName]);
            return {
                state: workingState,
                created: finalEntry
            };
        }

        var nextState = _immutableOps2.default.batch.merge(batchToken, (_ops$batch$merge2 = {}, (0, _defineProperty3.default)(_ops$batch$merge2, this.arrName, _immutableOps2.default.batch.push(batchToken, id, workingState[this.arrName])), (0, _defineProperty3.default)(_ops$batch$merge2, this.mapName, _immutableOps2.default.batch.merge(batchToken, (0, _defineProperty3.default)({}, id, finalEntry), workingState[this.mapName])), _ops$batch$merge2), workingState);

        return {
            state: nextState,
            created: finalEntry
        };
    };

    Table.prototype.update = function update(tx, branch, rows, mergeObj) {
        var _this3 = this;

        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;
        var mapName = this.mapName;


        var mapFunction = function mapFunction(row) {
            var merge = withMutations ? _immutableOps2.default.mutable.merge : _immutableOps2.default.batch.merge(batchToken);
            return merge(mergeObj, row);
        };

        var set = withMutations ? _immutableOps2.default.mutable.set : _immutableOps2.default.batch.set(batchToken);

        var newMap = rows.reduce(function (map, row) {
            var result = mapFunction(row);
            return set(result[_this3.idAttribute], result, map);
        }, branch[mapName]);
        return _immutableOps2.default.batch.set(batchToken, mapName, newMap, branch);
    };

    Table.prototype.delete = function _delete(tx, branch, rows) {
        var _this4 = this,
            _ops$batch$merge3;

        var batchToken = tx.batchToken,
            withMutations = tx.withMutations;
        var arrName = this.arrName,
            mapName = this.mapName;

        var arr = branch[arrName];

        var idsToDelete = rows.map(function (row) {
            return row[_this4.idAttribute];
        });
        if (withMutations) {
            idsToDelete.forEach(function (id) {
                var idx = arr.indexOf(id);
                if (idx !== -1) {
                    _immutableOps2.default.mutable.splice(idx, 1, [], arr);
                }

                _immutableOps2.default.mutable.omit(id, branch[mapName]);
            });
            return branch;
        }

        return _immutableOps2.default.batch.merge(batchToken, (_ops$batch$merge3 = {}, (0, _defineProperty3.default)(_ops$batch$merge3, arrName, _immutableOps2.default.batch.filter(batchToken, function (id) {
            return !(0, _utils.includes)(idsToDelete, id);
        }, branch[arrName])), (0, _defineProperty3.default)(_ops$batch$merge3, mapName, _immutableOps2.default.batch.omit(batchToken, idsToDelete, branch[mapName])), _ops$batch$merge3), branch);
    };

    return Table;
}();

exports.default = Table;